import { AnyAction } from "@reduxjs/toolkit";
import {
  GET_COMPANIES_DATA_REQUEST,
  GET_COMPANIES_DATA_SUCCESS,
  GET_COMPANIES_DATA_ERROR,
  GET_COMPANIES_FILTERS_REQUEST,
  GET_COMPANIES_FILTERS_SUCCESS,
  GET_COMPANIES_FILTERS_ERROR,
  SET_COMPANIES_FILTER_FIELD,
  CLEAR_COMPANIES_FILTERS,
} from "@kernel-store/actions";

export const getCompaniesDataRequest = (
  companiesByFieldParam: any,
): AnyAction => ({
  type: GET_COMPANIES_DATA_REQUEST,
  payload: { companiesByFieldParam },
});

export const getCompaniesDataSuccess = (companiesData: any): AnyAction => ({
  type: GET_COMPANIES_DATA_SUCCESS,
  payload: { companiesData },
});

export const getCompaniesDataError = (): AnyAction => ({
  type: GET_COMPANIES_DATA_ERROR,
  payload: {},
});

export const getCompaniesFiltersRequest = (): AnyAction => ({
  type: GET_COMPANIES_FILTERS_REQUEST,
  payload: {},
});

export const getCompaniesFiltersSuccess = (
  companiesFilters: any[],
): AnyAction => ({
  type: GET_COMPANIES_FILTERS_SUCCESS,
  payload: { companiesFilters },
});

export const getCompaniesFiltersError = (): AnyAction => ({
  type: GET_COMPANIES_FILTERS_ERROR,
  payload: {},
});

export const setCompaniesFilterField = (
  field: string,
  value: string,
): AnyAction => ({
  type: SET_COMPANIES_FILTER_FIELD,
  payload: { field, value },
});

export const clearCompaniesFilters = (): AnyAction => ({
  type: CLEAR_COMPANIES_FILTERS,
  payload: {},
});
